import { gsap } from 'gsap'

export const animateLogo = (target) => {
  var tl = gsap.timeline()
  tl.to(target, { opacity: 1, translateY: 0, duration: 1, ease: 'back.out(1.7)' })
  return tl
}

export const setLogo = (target) => {
  var tl = gsap.timeline()
  tl.set(target, { opacity: 0, translateY: -200 })
  return tl
}
